import { Component, OnInit, ViewChild, ViewEncapsulation, HostListener, TemplateRef } from '@angular/core';

import { UserService } from './../../services/user.service';
import { SLAKPIApiService } from './../../services/slakpi.service';
import { kpiDashboard_MoroDigitalInfra, kpiInbox, kpiUserActivities, quater, year } from './../../models/slakpi';
import { GoogleChartComponent } from 'ng2-google-charts';
declare var jquery: any;
declare var $: any;
declare var google: any;
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../services/utility.service';
import { color } from 'echarts';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { EChartOption } from 'echarts';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-dashboard-digital',
  templateUrl: './dashboard-digital.component.html',
  styleUrls: ['./dashboard-digital.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardDigitalComponent implements OnInit {
  modalRef: BsModalRef;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};

  filterQuarter_classactive: string = 'active';
  filterSubsidiary_classactive: string = '';
  noDataImg: any;
  tenantUno: any;
  user: any = {};
  chartOptions01: any = {};
  chartOptions02: any = {};
  chartOptions03: any = {};
  chartOptions04: any = {};

  chartOption04: any = {};
  chartOption05: any = {};

  chartOptionpie03: any = {};
  chartOptionpie02: any = {};
  chartOptionpie01: any = {};

  
  chartOptionSub01: any = {};
  chartOptionSub02: any = {};
  chartOptionSub03: any = {};
  chartOptionSub04: any = {};
  login_UserID: string; // number
  objDashboardList: any = [];
  public yearData: any;
  public quaterData: any;
  public monthData: any;
  public monthBasedQuarterData: any;
  public monthUno: any;
  public yearUno?: any = 0;
  public quarterUno?: any = 0;
  moroWPCount: number = 0;
  moroNWPCount: number = 0;
  digitalWPCount: number = 0;
  digitalNWPCount: number = 0;
  infraWPCount: number = 0;
  infraNWPCount: number = 0;
  public needleValue = 65;
  overAllPercentage: string = '';
  moroPercentage: string = '';
  digitalPercentage: string = '';
  infraPercentage: string = '';

 
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
    isAdmin: boolean;
    isPageLoad: boolean=true;
    selectedQuarter: string;
  isSum: boolean = false;
  isLandPageYear: boolean = false;
  constructor(private userService: UserService, public utilityService: UtilityService, public restApi: SLAKPIApiService, private router: Router, private spinner: SpinnerVisibilityService, private acroute: ActivatedRoute, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;

    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    this.isAdmin = (this.user != null && (this.user.role == 'Administrator' || this.user.role =='SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly')) ? true : false;
    if (!this.isAdmin) {
      this.router.navigateByUrl('/access-denied');
    }
    
    this.acroute.queryParams
      .subscribe(params => {
        
        if (params.issum != undefined && params.issum != null)

          if (params.issum==1)
            this.isSum = true;
        else
            this.isSum = false;

      }
      );

    
  }

  drawOpESchart = () => {

    const data = google.visualization.arrayToDataTable([
      ['Gen', 'Overall Digital DEWA', { role: 'style' }, { role: 'annotation' }],
      ['Overall Digital DEWA', 90, '#cccccc', '90%'],
      ['Moro Hub', 80, '#efc86c', '80%'],
      ['Digital X', 65, '#90ccd6', '65%'],
      ['Infra X', 70, '#197b9e', '70%']
    ]);

    const options = {
      title: "Employees Satisfaction (%)",
      //width: 600,
      //height: 400,
      legend: { position: 'top', maxLines: 3 },
      bar: { groupWidth: '30%' },
      chartArea: { width: '80%' },
      //isStacked: true,
      colors: ['#cccccc', '#efc86c', '#90ccd6', '#197b9e'],
    };

    const chart = new google.visualization.ColumnChart(document.getElementById('Op_Employee_Satisfaction_Chart'));
    chart.draw(data, options);
  }

  drawOpCSchart = () => {

    const data = google.visualization.arrayToDataTable([
      ['Percentage', 'Overall Digital DEWA', { role: 'style' }, { role: 'annotation' }],
      ['Overall Digital DEWA', 90, '#cccccc', '90%'],
      ['Moro Hub', 80, '#efc86c', '80%'],
      ['Digital X', 65, '#90ccd6', '65%'],
      ['Infra X', 70, '#197b9e', '70%']
    ]);

    const options = {
      title: "Customer Satisfaction (%)",

      legend: { position: 'top', maxLines: 3 },
      bar: { groupWidth: '30%' },
      chartArea: { width: '80%' },
      //isStacked: true,
      colors: ['#cccccc', '#efc86c', '#90ccd6', '#197b9e'],
    };

    const chart = new google.visualization.ColumnChart(document.getElementById('Op_Customer_Satisfaction_Chart'));
    chart.draw(data, options);
  }




  ngOnInit() {
    this.userService.CheckLogin();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'displayText',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };

    this.loadFilterValues();
    this.loadMonth();
    google.charts.load('current', { 'packages': ['corechart'] });
    //google.charts.setOnLoadCallback(this.drawOpRevenuechart);
    //google.charts.setOnLoadCallback(this.drawOpProfitchart);
    google.charts.setOnLoadCallback(this.drawOpESchart);
    google.charts.setOnLoadCallback(this.drawOpCSchart);
    //google.charts.setOnLoadCallback(this.drawMoroHubPieChartm);
    //google.charts.setOnLoadCallback(this.drawDigitalXPieChartm);
    //google.charts.setOnLoadCallback(this.drawInfraXPieChartm);

    this.isPageLoad = false;
  }
  //public canvasWidth
   
  //public centralLabel
  //public label
  //public bottomLabel
  //public bottomLabelFont = 50
  ////public options

  ////public canvasWidth = 180
  ////public needleValue = 65
  ////public centralLabel = ''
  //public name = ''
  //public options1 = {
  //  hasNeedle: false,
  //  // needleColor: 'gray',
  //  needleUpdateSpeed: 1000,
  //  arcColors: ['#087b36', '#e6e6e6'],
  //  arcDelimiters: [0.1],
  // // rangeLabel: ['0%', '100%'],
  //  arcPadding: 10
  //  //needleStartValue: 30,
  //  //rangeLabelFontSize: 30

  //}



  //public options2 = {
  //  hasNeedle: false,
  //  // needleColor: 'gray',
  //  needleUpdateSpeed: 1000,
  //  arcColors: ['#efc86c', '#e6e6e6'],
  //  arcDelimiters: [0.1]
  //}

  

  //public options3 = {
  //  hasNeedle: false,
  //  //needleColor: 'gray',
  //  needleUpdateSpeed: 1000,
  //  arcColors: ['#90ccd6', '#e6e6e6'],
  //  arcDelimiters: [0.1]
  //}

  

  //public options4 = {
  //  hasNeedle: false,
  //  //needleColor: 'gray',
  //  needleUpdateSpeed: 1000,
  //  arcColors: ['#197b9e', '#e6e6e6'],
  //  arcDelimiters: [0.1]
  //}
  onItemSelect(item: any) {
    

    this.selectedItems.push(item);
    this.callQuarterChangeMethod();
  }
  onSelectAll(items: any) {
    
    this.selectedItems = [];
    this.selectedItems = items
    this.callQuarterChangeMethod();
  }

  onItemDeSelect(item: any) {
    
    this.selectedItems = this.selectedItems.filter(x => x.value !== item.value)
    this.callQuarterChangeMethod();
  }
  onDeSelectAll(items: any) {
    
    this.selectedItems = [];
    this.callQuarterChangeMethod();
  }

  callQuarterChangeMethod() {
    let selectedQuarter = [];
    this.monthBasedQuarterData = [];
    if (this.selectedItems.length == 0) { this.monthBasedQuarterData = this.monthData; }

    for (let item of this.selectedItems) {
      let filterMonth = this.monthData.filter(x => x.Quarter == item.value);
      for (let month of filterMonth) {
        this.monthBasedQuarterData.push(month);
      }

      selectedQuarter.push(item.value);
      this.monthBasedQuarterData = this.sortByKeyAsc(this.monthBasedQuarterData, "value");
    }
    this.selectedQuarter = (selectedQuarter.length == 0) ? this.currentQuarter.toString() : selectedQuarter.toString();

    if (!this.isPageLoad) {
      this.getDashbordList();
    }
  }
  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        //this.sli_data = objdata.list_SLAMaster;
        //this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {

          this.yearUno = Number(this.yearUno);

          this.quarterUno = Number(this.quarterUno);

          this.getDashbordList(); //by filter

        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  getDashbordList() {
    
    this.spinner.show();
    let inpValue = new kpiDashboard_MoroDigitalInfra();
    inpValue.userUno = this.login_UserID;
    inpValue.currentYear = (this.yearUno == 0 || this.yearUno == undefined) ? 0 : this.yearUno;
    inpValue.currentQuarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? 0 : this.quarterUno; //this.quarterfilter ? this.quarterfilter : 0;
    inpValue.currentMonth = (this.monthUno == 0 || this.monthUno == undefined) ? 0 : this.monthUno;
    inpValue.reportingDivision = 0;//this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.dashboardType = 'report';
    inpValue.targetPercentage = 50;
    inpValue.selectedQuarterFilter = '';
    inpValue.selectedQuarterFilter = (typeof this.selectedQuarter != 'undefined' && this.selectedQuarter.length > 0) ? this.selectedQuarter.toString() : (this.monthUno != 0 && this.monthUno != undefined) ? this.getMonthQuarter() : this.currentQuarter.toString();

    if (this.selectedItems.length == 0 && inpValue.currentMonth == 0) {
      inpValue.selectedQuarterFilter = '1,2,3,4';
      this.isLandPageYear = true;
    }
    else {
      this.isLandPageYear = false;
    }
    this.moroWPCount = 0;
    this.moroNWPCount = 0;
    this.digitalWPCount = 0;
    this.digitalNWPCount = 0;
    this.infraWPCount = 0;
    this.infraNWPCount = 0;
    
    this.restApi.getKPIDashboard_MoroDigitalInfra(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          this.objDashboardList = data[0];

          //this.overAllPercentage = this.objDashboardList.overAllProfit.percentage;
          //this.moroPercentage = this.objDashboardList.moroProfit.percentage;
          //this.digitalPercentage = this.objDashboardList.digitalXProfit.percentage;
          //this.infraPercentage = this.objDashboardList.infraXProfit.percentage;
          this.chartOptions01 = {};
          this.chartOptions02 = {};
          this.chartOptions03 = {};
          this.chartOptions04= {};
          this.chartOption04 = {};
          this.chartOptionpie03 = {};
          this.chartOptionpie02 = {};
          this.chartOptionpie01 = {};
          this.chartOption05 = {};
         
          //By Quarter Revenuechart
          if (this.objDashboardList.listQRevenue.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              
              this.drawBYQuarterRevenuechart(this.objDashboardList.listQRevenue);
              this.spinner.hide();
            }, 100);
          }

          //By Sub Expenseschart
          if (this.objDashboardList.listQExpenses.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.drawBYQuarterExpenseschart(this.objDashboardList.listQExpenses);
              this.spinner.hide();
            }, 100);
          }

          //By Sub NetResultchart
          if (this.objDashboardList.listQNetResult.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.drawBYQuarterNetResultchart(this.objDashboardList.listQNetResult);
              this.spinner.hide();
            }, 100);
          }

          //By Sub EBITDAchart
          if (this.objDashboardList.listQEBITDA.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.drawBYQuarterEBITDAchart(this.objDashboardList.listQEBITDA);
              this.spinner.hide();
            }, 100);
          }

          //By Sub Revenuechart
          if (this.objDashboardList.listRevenue.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.drawBYSubRevenuechart(this.objDashboardList.listRevenue);
              this.spinner.hide();
            }, 100);
          }

          //By Sub Expenseschart
          if (this.objDashboardList.listExpenses.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              
              this.drawBYSubExpenseschart(this.objDashboardList.listExpenses);
              this.spinner.hide();
            }, 100);
          }

          //By Sub NetResultchart
          if (this.objDashboardList.listNetResult.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.drawBYSubNetResultchart(this.objDashboardList.listNetResult);
              this.spinner.hide();
            }, 100);
          }

          //By Sub EBITDAchart
          if (this.objDashboardList.listEBITDA.length > 0) {
            this.spinner.show();
            setTimeout(() => {

              this.drawBYSubEBITDAchart(this.objDashboardList.listEBITDA);
              this.spinner.hide();
            }, 100);
          }
          ////Profitchart
          //if (this.objDashboardList.listProfit.length > 0) {
          //  this.spinner.show();
          //  setTimeout(() => {
          //   this.drawOpProfitchart(this.objDashboardList.listProfit);
          //    this.spinner.hide();
          //  }, 100);
          //}

          //MoroHubPieChart
          if (this.objDashboardList.listMoroHubPerformance.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.drawMoroHubPieChartm(this.objDashboardList.listMoroHubPerformance);
              this.spinner.hide();
            }, 100);
          }

          //Digital X PieChart
          if (this.objDashboardList.listDigitalXPerformance.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.drawDigitalXPieChartm(this.objDashboardList.listDigitalXPerformance);
              this.spinner.hide();
            }, 100);
          }

          //Infra PieChart
          if (this.objDashboardList.listInfraXPerformance.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.drawInfraXPieChartm(this.objDashboardList.listInfraXPerformance);
              this.spinner.hide();
            }, 100);
          }



        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }
  drawBYQuarterRevenuechart = (option_data: any) => {
    
    let tempArrayYear = [];
    
    let tempArray_Actual = [];
    if (!this.isLandPageYear) {
      for (var i = 0; i < option_data.length; i++) {
        tempArrayYear.push(option_data[i].kpiYearQuarter);
        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        tempArray_Actual.push(parseInt(actualValue));

      }
    }
    else {

      tempArrayYear.push(this.yearUno);
      let sumactualValue: any = 0;
      for (var i = 0; i < option_data.length; i++) {

        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        sumactualValue = parseInt(sumactualValue) + parseInt(actualValue);

      }
      tempArray_Actual.push(sumactualValue);
    }

    //echarts starts
    this.chartOptions01 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
        
      },
      
      color: ['#68b097', '#9e9e9e'],
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30,
           

          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            
            formatter: function (value) {
              
             // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {
        
        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([

        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",
          
          label: {
            show: false,
            color: '#fff',

            position: 'outside',
            
            //formatter: function (value) {
            //  
            //  value = value.data;
            //  if (value >= 1000000000 || value <= -1000000000) {
            //    return Math.round(value / 1e9) + '1B';
            //  } else if (value >= 1000000 || value <= -1000000) {
            //    return Math.round(value / 1e6) + '1M';
            //  } else if (value >= 1000 || value <= -1000) {
            //    return Math.round(value / 1e3) + '1K';
                
            //  }
            //  return value;

            //}
          },
        }
      ])
    };

   

    //echarts ends
  }

  drawBYQuarterExpenseschart = (option_data: any) => {

    let tempArrayYear = [];

    let tempArray_Actual = [];
    if (!this.isLandPageYear) {
      for (var i = 0; i < option_data.length; i++) {
        tempArrayYear.push(option_data[i].kpiYearQuarter);
        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        tempArray_Actual.push(parseInt(actualValue));

      }
    }
    else {

      tempArrayYear.push(this.yearUno);
      let sumactualValue: any = 0;
      for (var i = 0; i < option_data.length; i++) {

        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        sumactualValue = parseInt(sumactualValue) + parseInt(actualValue);

      }
      tempArray_Actual.push(sumactualValue);
    }

    //echarts starts
    this.chartOptions02 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      color: ['#68b097', '#9e9e9e'],
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/10000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([

        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
            formatter: function (value) {
             
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          },
        }
      ])
    };



    //echarts ends
  }

  drawBYQuarterNetResultchart = (option_data: any) => {

    let tempArrayYear = [];

    let tempArray_Actual = [];
    if (!this.isLandPageYear) {
      for (var i = 0; i < option_data.length; i++) {
        tempArrayYear.push(option_data[i].kpiYearQuarter);
        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        tempArray_Actual.push(parseInt(actualValue));

      }
    }
    else {

      tempArrayYear.push(this.yearUno);
      let sumactualValue: any = 0;
      for (var i = 0; i < option_data.length; i++) {

        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        sumactualValue = parseInt(sumactualValue) + parseInt(actualValue);

      }
      tempArray_Actual.push(sumactualValue);
    }

    //echarts starts
    this.chartOptions03 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      color: ['#68b097', '#9e9e9e'],
      
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([

        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          },
        }
      ])
    };



    //echarts ends
  }

  drawBYQuarterEBITDAchart = (option_data: any) => {

    let tempArrayYear = [];

    let tempArray_Actual = [];

    if (!this.isLandPageYear) {
      for (var i = 0; i < option_data.length; i++) {
        tempArrayYear.push(option_data[i].kpiYearQuarter);
        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        tempArray_Actual.push(parseInt(actualValue));

      }
    }
    else {
  
      tempArrayYear.push(this.yearUno);
      let sumactualValue:any=0;
      for (var i = 0; i < option_data.length; i++) {
        
        let actualValue = (option_data[i].actualValue != null) ? option_data[i].actualValue : 0;
        sumactualValue = parseInt(sumactualValue) + parseInt(actualValue);

      }
      tempArray_Actual.push(sumactualValue);
    }
    //echarts starts

    
    this.chartOptions04 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      
      color: ['#68b097', '#9e9e9e'],
      
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }

        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([

        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6);
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          },
        }
      ])
    };



    //echarts ends
  }

  drawBYSubRevenuechart = (option_data: any) => {


    let tempMoroTartget = [];
    let tempMoroActual = [];

    let tempDigitalTartget = [];
    let tempDigitalActual = [];

    let tempInfraTartget = [];
    let tempInfraActual = [];


    let tempArrayYear = [];
    let tempArray_Actual = [];
    let tempArray_Target = [];
    let uniqueItem = [];
    uniqueItem = this.uniqueArray(option_data, "kpiYearQuarter", "kpiYearQuarter");



    for (var i = 0; i < uniqueItem.length; i++) {

      let selectedItem = [];
      tempArrayYear.push(uniqueItem[i].label);
      selectedItem = option_data.filter(x => x.kpiYearQuarter == uniqueItem[i].label);
      if (selectedItem.length > 1) {
        let moroActual = (selectedItem[0].moro != null) ? selectedItem[0].moro : 0;
        let digitalActual = (selectedItem[0].digitalX != null) ? selectedItem[0].digitalX : 0;
        let infraActual = (selectedItem[0].infraX != null) ? selectedItem[0].infraX : 0;
        let SumofActual = (moroActual + digitalActual + infraActual);

        let divideCount = 0;
        if (moroActual != 0) { divideCount += 1; }
        if (digitalActual != 0) { divideCount += 1; }
        if (infraActual != 0) { divideCount += 1; }
        if (!this.isSum)
          SumofActual = (SumofActual != 0) ? (parseInt(SumofActual) / divideCount) : 0;
        else
          SumofActual = (SumofActual != 0) ? parseInt(SumofActual) : 0;

        if (SumofActual != 0) {
          tempArray_Actual.push(parseInt(SumofActual));
        }

        if (moroActual != 0) {
          tempMoroActual.push(parseInt(moroActual));
        }
        if (digitalActual != 0) {
          tempDigitalActual.push(parseInt(digitalActual));
        }
        if (infraActual != 0) {
          tempInfraActual.push(parseInt(infraActual));
        }


        let moroTarget = (selectedItem[1].moro != null) ? selectedItem[1].moro : 0;
        let digitalTarget = (selectedItem[1].digitalX != null) ? selectedItem[1].digitalX : 0;
        let infraTarget = (selectedItem[1].infraX != null) ? selectedItem[1].infraX : 0;
        let SumofTarget = (moroTarget + digitalTarget + infraTarget);

        if (!this.isSum)
          SumofTarget = (SumofTarget != 0) ? (parseInt(SumofTarget) / divideCount) : 0;
        else
          SumofTarget = (SumofTarget != 0) ? parseInt(SumofTarget) : 0;

        if (SumofTarget != 0) {
          tempArray_Target.push(parseInt(SumofTarget));
        }


        if (moroTarget != 0) {
          tempMoroTartget.push(parseInt(moroTarget));
        }
        if (digitalTarget != 0) {
          tempDigitalTartget.push(parseInt(digitalTarget));
        }
        if (infraTarget != 0) {
          tempInfraTartget.push(parseInt(infraTarget));
        }
      }
    }

    //echarts starts
    
    this.chartOptionSub01 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      // color: ['#efc86c', '#90ccd6', '#197b9e', '#fff'],
      legend: {

        data: ['Moro', 'Digital X', 'Infra X'],
        itemWidth: 17,
        left: 'left',
        padding: [
          10,  // up
          0, // right
          0,  // down
          10, // left
        ],
      },
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([
        {
          name: 'Target',
          type: 'bar',
          data: tempArray_Target,
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          color: "#68b097",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
       
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
        {
          name: 'Moro Target',
          type: 'bar',
          data: tempMoroTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Moro Actual',
          type: 'bar',
          data: tempMoroActual,
          //barWidth: "10%",
          color: "#efc86c",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
         // barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
          }
        },
        {
          name: 'DigitalX Target',
          type: 'bar',
          data: tempDigitalTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'DigitalX Actual',
          type: 'bar',
          data: tempDigitalActual,
          //barWidth: "10%",
          color: "#90ccd6",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
          }
        },
        {
          name: 'InfraX Target',
          type: 'bar',
          data: tempInfraTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'InfraX Actual',
          type: 'bar',
          data: tempInfraActual,
          //barWidth: "10%",
          color: "#197b9e",
          label: {
            show: true,
           //color: '#197b9e',
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "1%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
      ])
    };


    //echarts ends
  }

  drawBYSubExpenseschart = (option_data: any) => {

    let tempMoroTartget = [];
    let tempMoroActual = [];

    let tempDigitalTartget = [];
    let tempDigitalActual = [];

    let tempInfraTartget = [];
    let tempInfraActual = [];


    let tempArrayYear = [];
    let tempArray_Actual = [];
    let tempArray_Target = [];
    let uniqueItem = [];
    uniqueItem = this.uniqueArray(option_data, "kpiYearQuarter", "kpiYearQuarter");



    for (var i = 0; i < uniqueItem.length; i++) {

      let selectedItem = [];
      tempArrayYear.push(uniqueItem[i].label);
      selectedItem = option_data.filter(x => x.kpiYearQuarter == uniqueItem[i].label);
      if (selectedItem.length > 1) {
        let moroActual = (selectedItem[0].moro != null) ? selectedItem[0].moro : 0;
        let digitalActual = (selectedItem[0].digitalX != null) ? selectedItem[0].digitalX : 0;
        let infraActual = (selectedItem[0].infraX != null) ? selectedItem[0].infraX : 0;
        let SumofActual = (moroActual + digitalActual + infraActual);

        let divideCount = 0;
        if (moroActual != 0) { divideCount += 1; }
        if (digitalActual != 0) { divideCount += 1; }
        if (infraActual != 0) { divideCount += 1; }
        if (!this.isSum)
          SumofActual = (SumofActual != 0) ? (parseInt(SumofActual) / divideCount) : 0;
        else
          SumofActual = (SumofActual != 0) ? parseInt(SumofActual) : 0;

        if (SumofActual != 0) {
          tempArray_Actual.push(parseInt(SumofActual));
        }

        if (moroActual != 0) {
          tempMoroActual.push(parseInt(moroActual));
        }
        if (digitalActual != 0) {
          tempDigitalActual.push(parseInt(digitalActual));
        }
        if (infraActual != 0) {
          tempInfraActual.push(parseInt(infraActual));
        }


        let moroTarget = (selectedItem[1].moro != null) ? selectedItem[1].moro : 0;
        let digitalTarget = (selectedItem[1].digitalX != null) ? selectedItem[1].digitalX : 0;
        let infraTarget = (selectedItem[1].infraX != null) ? selectedItem[1].infraX : 0;
        let SumofTarget = (moroTarget + digitalTarget + infraTarget);

        if (!this.isSum)
          SumofTarget = (SumofTarget != 0) ? (parseInt(SumofTarget) / divideCount) : 0;
        else
          SumofTarget = (SumofTarget != 0) ? parseInt(SumofTarget) : 0;

        if (SumofTarget != 0) {
          tempArray_Target.push(parseInt(SumofTarget));
        }


        if (moroTarget != 0) {
          tempMoroTartget.push(parseInt(moroTarget));
        }
        if (digitalTarget != 0) {
          tempDigitalTartget.push(parseInt(digitalTarget));
        }
        if (infraTarget != 0) {
          tempInfraTartget.push(parseInt(infraTarget));
        }
      }
    }

    //echarts starts

    this.chartOptionSub02 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      // color: ['#efc86c', '#90ccd6', '#197b9e', '#fff'],
      legend: {

        data: ['Moro', 'Digital X', 'Infra X'],
        itemWidth: 17,
        left: 'left',
        padding: [
          10,  // up
          0, // right
          0,  // down
          10, // left
        ],
      },
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([
        {
          name: 'Target',
          type: 'bar',
          data: tempArray_Target,
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          color: "#68b097",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000;
              }
              return value;

            }
          }
        },
       
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
        {
          name: 'Moro Target',
          type: 'bar',
          data: tempMoroTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Moro Actual',
          type: 'bar',
          data: tempMoroActual,
          //barWidth: "10%",
          color: "#efc86c",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          // barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#9e9e9e',
            position: 'outside',
          }
        },
        {
          name: 'DigitalX Target',
          type: 'bar',
          data: tempDigitalTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'DigitalX Actual',
          type: 'bar',
          data: tempDigitalActual,
          //barWidth: "10%",
          color: "#90ccd6",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#9e9e9e',
            position: 'outside',
          }
        },
        {
          name: 'InfraX Target',
          type: 'bar',
          data: tempInfraTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'InfraX Actual',
          type: 'bar',
          data: tempInfraActual,
          //barWidth: "10%",
          color: "#197b9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "1%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
      ])
    };


    //echarts ends
  }
  
  drawBYSubNetResultchart = (option_data: any) => {


    let tempMoroTartget = [];
    let tempMoroActual = [];

    let tempDigitalTartget = [];
    let tempDigitalActual = [];

    let tempInfraTartget = [];
    let tempInfraActual = [];


    let tempArrayYear = [];
    let tempArray_Actual = [];
    let tempArray_Target = [];
    let uniqueItem = [];
    uniqueItem = this.uniqueArray(option_data, "kpiYearQuarter", "kpiYearQuarter");



    for (var i = 0; i < uniqueItem.length; i++) {

      let selectedItem = [];
      tempArrayYear.push(uniqueItem[i].label);
      selectedItem = option_data.filter(x => x.kpiYearQuarter == uniqueItem[i].label);
      if (selectedItem.length > 1) {
        let moroActual = (selectedItem[0].moro != null) ? selectedItem[0].moro : 0;
        let digitalActual = (selectedItem[0].digitalX != null) ? selectedItem[0].digitalX : 0;
        let infraActual = (selectedItem[0].infraX != null) ? selectedItem[0].infraX : 0;
        let SumofActual = (moroActual + digitalActual + infraActual);

        let divideCount = 0;
        if (moroActual != 0) { divideCount += 1; }
        if (digitalActual != 0) { divideCount += 1; }
        if (infraActual != 0) { divideCount += 1; }
        if (!this.isSum)
          SumofActual = (SumofActual != 0) ? (parseInt(SumofActual) / divideCount) : 0;
        else
          SumofActual = (SumofActual != 0) ? parseInt(SumofActual) : 0;


        if (SumofActual != 0) {
          tempArray_Actual.push(parseInt(SumofActual));
        }

        if (moroActual != 0) {
          tempMoroActual.push(parseInt(moroActual));
        }
        if (digitalActual != 0) {
          tempDigitalActual.push(parseInt(digitalActual));
        }
        if (infraActual != 0) {
          tempInfraActual.push(parseInt(infraActual));
        }


        let moroTarget = (selectedItem[1].moro != null) ? selectedItem[1].moro : 0;
        let digitalTarget = (selectedItem[1].digitalX != null) ? selectedItem[1].digitalX : 0;
        let infraTarget = (selectedItem[1].infraX != null) ? selectedItem[1].infraX : 0;
        let SumofTarget = (moroTarget + digitalTarget + infraTarget);

        if (!this.isSum)
          SumofTarget = (SumofTarget != 0) ? (parseInt(SumofTarget) / divideCount) : 0;
        else
          SumofTarget = (SumofTarget != 0) ? parseInt(SumofTarget) : 0;
        if (SumofTarget != 0) {
          tempArray_Target.push(parseInt(SumofTarget));
        }


        if (moroTarget != 0) {
          tempMoroTartget.push(parseInt(moroTarget));
        }
        if (digitalTarget != 0) {
          tempDigitalTartget.push(parseInt(digitalTarget));
        }
        if (infraTarget != 0) {
          tempInfraTartget.push(parseInt(infraTarget));
        }
      }
    }

    //echarts starts

    this.chartOptionSub03 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      // color: ['#efc86c', '#90ccd6', '#197b9e', '#fff'],
      legend: {

        data: ['Moro', 'Digital X', 'Infra X'],
        itemWidth: 17,
        left: 'left',
        padding: [
          10,  // up
          0, // right
          0,  // down
          10, // left
        ],
      },
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([
        {
          name: 'Target',
          type: 'bar',
          data: tempArray_Target,
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          color: "#68b097",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
        {
          name: 'Moro Target',
          type: 'bar',
          data: tempMoroTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Moro Actual',
          type: 'bar',
          data: tempMoroActual,
          //barWidth: "10%",
          color: "#efc86c",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          // barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#9e9e9e',
            position: 'outside',
          }
        },
        {
          name: 'DigitalX Target',
          type: 'bar',
          data: tempDigitalTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'DigitalX Actual',
          type: 'bar',
          data: tempDigitalActual,
          //barWidth: "10%",
          color: "#90ccd6",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#9e9e9e',
            position: 'outside',
          }
        },
        {
          name: 'InfraX Target',
          type: 'bar',
          data: tempInfraTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) ;
              }
              return value;

            }
          }
        },
        {
          name: 'InfraX Actual',
          type: 'bar',
          data: tempInfraActual,
          //barWidth: "10%",
          color: "#197b9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3)/1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "1%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
      ])
    };


    //echarts ends
  }

  drawBYSubEBITDAchart = (option_data: any) => {


    let tempMoroTartget = [];
    let tempMoroActual = [];

    let tempDigitalTartget = [];
    let tempDigitalActual = [];

    let tempInfraTartget = [];
    let tempInfraActual = [];


    let tempArrayYear = [];
    let tempArray_Actual = [];
    let tempArray_Target = [];
    let uniqueItem = [];
    uniqueItem = this.uniqueArray(option_data, "kpiYearQuarter", "kpiYearQuarter");



    for (var i = 0; i < uniqueItem.length; i++) {

      let selectedItem = [];
      tempArrayYear.push(uniqueItem[i].label);
      selectedItem = option_data.filter(x => x.kpiYearQuarter == uniqueItem[i].label);
      if (selectedItem.length > 1) {
        let moroActual = (selectedItem[0].moro != null) ? selectedItem[0].moro : 0;
        let digitalActual = (selectedItem[0].digitalX != null) ? selectedItem[0].digitalX : 0;
        let infraActual = (selectedItem[0].infraX != null) ? selectedItem[0].infraX : 0;
        let SumofActual = (moroActual + digitalActual + infraActual);

        let divideCount = 0;
        if (moroActual != 0) { divideCount += 1; }
        if (digitalActual != 0) { divideCount += 1; }
        if (infraActual != 0) { divideCount += 1; }

        if (!this.isSum)
          SumofActual = (SumofActual != 0) ? (parseInt(SumofActual) / divideCount) : 0;
        else
          SumofActual = (SumofActual != 0) ? parseInt(SumofActual) : 0;

        if (SumofActual != 0) {
          tempArray_Actual.push(parseInt(SumofActual));
        }

        if (moroActual != 0) {
          tempMoroActual.push(parseInt(moroActual));
        }
        if (digitalActual != 0) {
          tempDigitalActual.push(parseInt(digitalActual));
        }
        if (infraActual != 0) {
          tempInfraActual.push(parseInt(infraActual));
        }


        let moroTarget = (selectedItem[1].moro != null) ? selectedItem[1].moro : 0;
        let digitalTarget = (selectedItem[1].digitalX != null) ? selectedItem[1].digitalX : 0;
        let infraTarget = (selectedItem[1].infraX != null) ? selectedItem[1].infraX : 0;
        let SumofTarget = (moroTarget + digitalTarget + infraTarget);
        if (!this.isSum)
          SumofTarget = (SumofTarget != 0) ? (parseInt(SumofTarget) / divideCount) : 0;
        else
          SumofTarget = (SumofTarget != 0) ? parseInt(SumofTarget) : 0;

        if (SumofTarget != 0) {
          tempArray_Target.push(parseInt(SumofTarget));
        }


        if (moroTarget != 0) {
          tempMoroTartget.push(parseInt(moroTarget));
        }
        if (digitalTarget != 0) {
          tempDigitalTartget.push(parseInt(digitalTarget));
        }
        if (infraTarget != 0) {
          tempInfraTartget.push(parseInt(infraTarget));
        }
      }
    }

    //echarts starts

    this.chartOptionSub04 = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          show: false,
          type: 'shadow',
          //lineStyle: {
          //  type: 'dashed',
          //  width: 0
          //}
        },
      },
      // color: ['#efc86c', '#90ccd6', '#197b9e', '#fff'],
      legend: {

        data: ['Moro', 'Digital X', 'Infra X'],
        itemWidth: 17,
        left: 'left',
        padding: [
          10,  // up
          0, // right
          0,  // down
          10, // left
        ],
      },
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArrayYear,
          axisLabel: {
            outside: true,
            margin: 30
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              
              // value = value;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + 'B';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        }
      ],
      grid: {

        top: '20%',
        bottom: '10%',
        containLabel: true,
        left: '3%',
        right: '4%',
        color: '#fff'
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: this.seriesHandler([
        {
          name: 'Target',
          type: 'bar',
          data: tempArray_Target,
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          color: "#68b097",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
        {
          name: 'Moro Target',
          type: 'bar',
          data: tempMoroTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'Moro Actual',
          type: 'bar',
          data: tempMoroActual,
          //barWidth: "10%",
          color: "#efc86c",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          // barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
          }
        },
        {
          name: 'DigitalX Target',
          type: 'bar',
          data: tempDigitalTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'DigitalX Actual',
          type: 'bar',
          data: tempDigitalActual,
          //barWidth: "10%",
          color: "#90ccd6",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "3%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
          }
        },
        {
          name: 'InfraX Target',
          type: 'bar',
          data: tempInfraTartget,
          //barWidth: "10%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6) ;
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: 'InfraX Actual',
          type: 'bar',
          data: tempInfraActual,
          //barWidth: "10%",
          color: "#197b9e",
          label: {
            show: true,
            // color: '#197b9e',
            color: '#000',
            position: 'outside',
            formatter: function (value) {
              
              value = value.data;
              if (value >= 1000000000 || value <= -1000000000) {
                return Math.round(value / 1e9) + '\nB';
              } else if (value >= 1000000 || value <= -1000000) {
                return Math.round(value / 1e6);
              } else if (value >= 1000 || value <= -1000) {
                return Math.round(value / 1e3) / 1000 ;
              }
              return value;

            }
          }
        },
        {
          name: '',
          type: 'bar',
          //data: [],
          //barWidth: "1%",
          color: "#9e9e9e",
          label: {
            show: true,
            color: '#fff',
            position: 'outside',
          }
        },
      ])
    };


    //echarts ends
  }
  
  drawMoroHubPieChartm = (option_data: any) => {
    //  let tempArray = [['Moro Hub', 'Types of Reports Submitted']];
    //  let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
    //    return a + b;
    //  });

    //  let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
    //    return a + b;
    //  });
    //  this.moroWPCount = wellPerformanceCount;
    //  this.moroNWPCount = notwellPerformanceCount;

    //  tempArray.push(['Well Performed', wellPerformanceCount]);
    //  tempArray.push(['Not Well Performed', notwellPerformanceCount]);
    //  var data = google.visualization.arrayToDataTable(tempArray);
    //  //const data = google.visualization.arrayToDataTable([
    //  //  ['Moro Hub', 'Types of Reports Submitted'],
    //  //  ['KPIs', 75],
    //  //  ['SLAs', 25],
    //  //]);

    //  const options = {
    //    //title: 'Types of Reports Submitted',
    //    colors: ['#68b097', '#bcbcbc'],
    //    legend: { position: 'none' },
    //    chartArea: { left: 10, right: 10, top: 0, bottom: 0, width: "100%", height: "100%" },
    //    fontSize: 15,

    //  };

    //  const chart = new google.visualization.PieChart(document.getElementById('Morohub_Pie'));
    //  chart.draw(data, options);
    //}


   



    //let tempArray = [['Moro Hub', 'Types of Reports Submitted']];
    let tempArray = [];
      let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
        return a + b;
      });

      let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
        return a + b;
      });
      this.moroWPCount = wellPerformanceCount;
    this.moroNWPCount = notwellPerformanceCount;

   

    //  tempArray.push(['Well Performed', wellPerformanceCount]);
    //  tempArray.push(['Not Well Performed', notwellPerformanceCount]);
    //  var data = google.visualization.arrayToDataTable(tempArray);
    let WPPercentage = Math.round((parseInt(wellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);
    let NWPPercentage = Math.round((parseInt(notwellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);

  

    //echarts starts
    this.chartOptionpie01 = {
      title: {
        text: '',
        //subtext: '纯属虚构',
        left: 'center'
      },
      color: ['#68b097', '#bcbcbc'],
      tooltip: {
        trigger: 'item',
        backgroundColor: '#fff',
        borderWidth:0,
        textStyle: {
          color: '#212529'
        }
      },
      legend: {
        show: false,
        orient: 'vertical',
        left: 'right',
        align: 'left'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: '80%',
          center: ['45%', '50%'],
         
          data: [
           

            { value: (this.moroWPCount == 0) ? '' : this.moroWPCount, name: (WPPercentage == 0) ? '' : WPPercentage + '%' },
            { value: (this.moroNWPCount == 0) ? '' : this.moroNWPCount, name: (NWPPercentage == 0) ? '' : NWPPercentage + '%' },
          ],
          label: {
            show: true,
            position: (WPPercentage == 100 || NWPPercentage == 100) ? 'center' : 'inner',
            color: 'white',
            fontSize:15
          },
          labelLine: {
            show: true
          },
          emphasis: {

            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    //echarts ends
  }

  drawDigitalXPieChartm = (option_data: any) => {

    

    let tempArray = [];
    let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
      return a + b;
    });

    let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
      return a + b;
    });
    this.digitalWPCount = wellPerformanceCount;
    this.digitalNWPCount = notwellPerformanceCount;

    let WPPercentage = Math.round((parseInt(wellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);
    let NWPPercentage = Math.round((parseInt(notwellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);
    //echarts starts
    this.chartOptionpie02 = {
      title: {
        text: '',
        //subtext: '纯属虚构',
        left: 'center'
      },
      color: ['#68b097', '#bcbcbc'],
      tooltip: {
        trigger: 'item',
        backgroundColor: '#fff',
        borderWidth: 0,
        textStyle: {
          color: '#212529'
        }
      },
     
      legend: {
        show: false,
        orient: 'vertical',
        left: 'right',
        align: 'left'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: '80%',
          center: ['45%', '50%'],
          data: [
            //{ value: this.digitalWPCount, name: WPPercentage + '%' },
            //{ value: this.digitalNWPCount, name: NWPPercentage + '%' },

            { value: (this.digitalWPCount == 0) ? '' : this.digitalWPCount, name: (WPPercentage == 0) ? '' : WPPercentage + '%' },
            { value: (this.digitalNWPCount == 0) ? '' : this.digitalNWPCount, name: (NWPPercentage == 0) ? '' : NWPPercentage + '%' },
          ],
          label: {
            show: true,
            position: (WPPercentage == 100 || NWPPercentage == 100) ? 'center' : 'inner',
            color: 'white',
            fontSize: 15
          },
          labelLine: {
            show: false
          },

          emphasis: {

            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    //echarts ends
  }
  drawInfraXPieChartm = (option_data: any) => {

    //  let tempArray = [['Moro Hub', 'Types of Reports Submitted']];
    //  let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
    //    return a + b;
    //  });

    //  let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
    //    return a + b;
    //  });
    //  this.infraWPCount = wellPerformanceCount;
    //  this.infraNWPCount = notwellPerformanceCount;
    //  tempArray.push(['Well Performed', wellPerformanceCount]);
    //  tempArray.push(['Not Well Performed', notwellPerformanceCount]);
    //  var data = google.visualization.arrayToDataTable(tempArray);
    //  //const data = google.visualization.arrayToDataTable([
    //  //  ['Moro Hub', 'Types of Reports Submitted'],
    //  //  ['KPIs', 75],
    //  //  ['SLAs', 25],
    //  //]);

    //  const options = {
    //    //title: 'Types of Reports Submitted',
    //    colors: ['#68b097', '#bcbcbc'],
    //    legend: { position: 'none' },
    //    chartArea: { left: 10, right: 10, top: 0, bottom: 0, width: "100%", height: "100%" },
    //    fontSize: 15
    //  };

    //  const chart = new google.visualization.PieChart(document.getElementById('Infrax_Pie'));
    //  chart.draw(data, options);
    //}
    let tempArray = [];
    let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
      return a + b;
    });

    let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
      return a + b;
    });
    this.infraWPCount = wellPerformanceCount;
    this.infraNWPCount = notwellPerformanceCount;

    let WPPercentage = Math.round((parseInt(wellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);
    let NWPPercentage = Math.round((parseInt(notwellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);

    //echarts starts
    this.chartOptionpie03 = {
      title: {
        text: '',
        //subtext: '纯属虚构',
        left: 'center'
      },
      color: ['#68b097', '#bcbcbc'],
      tooltip: {
        trigger: 'item',
        backgroundColor: '#fff',
        borderWidth: 0,
        textStyle: {
          color: '#212529'
        }
      },
      legend: {
        show: false,
        orient: 'vertical',
        left: 'right',
        align: 'left'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: '80%',
          center: ['45%', '50%'],
          data: [
            { value: (this.infraWPCount == 0) ? '' : this.infraWPCount, name: (WPPercentage==0)?'': WPPercentage + '%' },
            { value: (this.infraNWPCount == 0) ? '' : this.infraNWPCount,  name: (NWPPercentage == 0) ? '' : NWPPercentage + '%' },


          ],
          label: {
            show: true,
            position: (WPPercentage == 100 || NWPPercentage == 100) ? 'center' : 'inner',

            color: 'white',
            fontSize: 15
          },
          labelLine: {
            show: false
          },
          emphasis: {

            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    //echarts ends
  }
  onchangeYear(e) {
    
    this.yearUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    if (!this.isPageLoad) {
      this.getDashbordList();
    }

  }


  onchangeQuarter(e) {
    
    //this.quarterUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    //if (!this.isPageLoad) {
    //  this.getDashbordList();
    //}

    
    let selectedQuarter = [];
    this.monthBasedQuarterData = [];
    if (e.length == 0) { this.monthBasedQuarterData = this.monthData;}

    for (let item of e) {
      let filterMonth = this.monthData.filter(x => x.Quarter == item.value);
      for (let month of filterMonth) {
        this.monthBasedQuarterData.push(month);
      }

      selectedQuarter.push(item.value);
      this.monthBasedQuarterData = this.sortByKeyAsc(this.monthBasedQuarterData,"value");
    }
    this.selectedQuarter = (selectedQuarter.length == 0) ? this.currentQuarter.toString() : selectedQuarter.toString();

    if (!this.isPageLoad) {
      this.getDashbordList();
    }
  }

  onchangeMonth(e) {
    
    this.monthUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.getDashbordList();
  }
  loadMonth() {
    this.monthData = [
      { value: 1,  Quarter:1, displayText: 'January' },
      { value: 2,  Quarter:1, displayText: 'February' },
      { value: 3,  Quarter:1, displayText: 'March' },
      { value: 4, Quarter:2, displayText: 'April' },
      { value: 5, Quarter:2, displayText: 'May' },
      { value: 6, Quarter:2, displayText: 'June' },
      { value: 7, Quarter:3, displayText: 'July' },
      { value: 8, Quarter:3, displayText: 'August' },
      { value: 9, Quarter:3, displayText: 'September' },
      { value: 10, Quarter:4, displayText: 'October' },
      { value: 11, Quarter:4, displayText: 'November' },
      { value: 12, Quarter:4, displayText: 'December' }
    ];

    this.monthBasedQuarterData = this.monthData;
  }

  sortByKeyAsc(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  formatNumbers(value) {
    if (value >= 1000000000 || value <= -1000000000) {
      return value / 1e9 + 'B';
    } else if (value >= 1000000 || value <= -1000000) {
      return value / 1e6 + 'M';
    } else if (value >= 1000 || value <= -1000) {
      return value / 1e3 + 'K';
    }
    return value;
  }

  getMonthQuarter() {
    let rtnValue = this.currentQuarter;
    if(this.monthUno >0 && this.monthUno <=3)
      rtnValue= 1;
    if (this.monthUno >3 && this.monthUno <= 6)
      rtnValue = 2;
    if (this.monthUno > 6 && this.monthUno <= 9)
      rtnValue = 3;
    if (this.monthUno > 9 && this.monthUno <= 12)
      rtnValue = 4;

    return rtnValue.toString();
  }
   seriesHandler = series => {
    return series.map((serie, index) => {
      if (index === series.length - 1) {
        return {
          ...serie,
          label: {

            normal: {
              show: true,
              color:'#000',
              position: 'outside',

              formatter: params => {
                let total = 0
                series.forEach(s => {
                  total += s.data[params.dataIndex]
                })

                total = Math.round(total);
                if (total >= 1000000000 || total <= -1000000000) {
                  return Math.round(total / 1e9) + '\nB';
                } else if (total >= 1000000 || total <= -1000000) {
                  return Math.round(total / 1e6) ;
                } else if (total >= 1000 || total <= -1000) {
                  return Math.round(total / 1e3)/1000 ;
                }
                return total;


              }
            }
          }
        }
      } else {
        return serie
      }
    })
  }

  onfilterData(type: string) {
    if (type == "Quarter") {
      this.filterQuarter_classactive = 'active';
      this.filterSubsidiary_classactive = '';
    } else {
      this.filterQuarter_classactive = '';
      this.filterSubsidiary_classactive = 'active';
    }
  }

  kpiperformanceredirect(strValue: string, strPillar: string, bandValue: string) {
    
    strValue = (strValue != null && strValue != '') ? strValue : "";
    let strYear = (this.yearUno == 0 || this.yearUno == undefined) ? 0 : this.yearUno;
    let strQuarter = (typeof this.selectedQuarter != 'undefined' && this.selectedQuarter.length ==1) ? this.selectedQuarter.toString() : (this.monthUno != 0 && this.monthUno != undefined) ? this.getMonthQuarter() : 0;
    let strMonth = (this.monthUno == 0 || this.monthUno == undefined) ? 0 : this.monthUno;

    if (strPillar == '' && bandValue == '') {
      this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: strYear, quatersla: strQuarter, monthsla: strMonth, pagetype: strValue} });
      return false;
    }
    if (strPillar == '' && bandValue != '') {
      this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: strYear, quatersla: strQuarter, monthsla: strMonth, pagetype: strValue, performance: bandValue } });
      return false;
    }

    if (bandValue != '') {      
      this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: strYear, quatersla: strQuarter, monthsla:strMonth,pagetype: strValue, pillarType: strPillar, performance: bandValue } });
      //this.router.navigate(["/translate-page", { returnUrl: '/slakpiperformance?pagetype=' + strValue + '&pillarType=' + strPillar + '&performance=' + bandValue }]);
    } else {      
      this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: strYear, quatersla: strQuarter, monthsla: strMonth,pagetype: strValue, pillarType: strPillar } });
    }
    
    return false;
  }
  

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }
  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static',
      class: 'gray modal-xl modal-full',
    });
  }
}
